export const carouselOptions = {
  "#top-tours": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 4,
      desktop: 4,
    },
    arrowsVisible: true,
    indicatorVisible: false,
  },
  "#about-sd": {
    breakpoints: {
      mobile: 1,
      tablet: 3,
      laptop: 3,
      desktop: 3,
    },
  },
  "#travel-specialists": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: false,
  },
  "#carousel-offers": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 3,
    },
    indicatorVisible: true,
  },
  "#carousel-experiences": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 3,
    },
  },
  "#travel-specialist": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 3,
    },
    arrowsVisible: true,
    indicatorVisible: false,
  },
  "#breathtalking-holidays": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 3,
    },
  },
  "#intersted-hotels": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 4,
    },
  },
  "#top-picks": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: false,
  },
  "#itinerary-offers": {
    breakpoints: {
      mobile: 1,
      tablet: 3,
      laptop: 3,
      desktop: 3,
    },
    arrowsVisible: false,
  },
  "#intersted-blogs": {
    breakpoints: {
      mobile: 1,
      tablet: 4,
      laptop: 4,
      desktop: 4,
    },
  },
  "#landing-videos": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
  },
  "#landing-did-you-know": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: false,
  },
  "#landing-specialists": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    slideDuration: 3000,
    autoplay: true,
    arrowsVisible: false,
  },
  "#landing-tours": {
    breakpoints: {
      mobile: 1,
      tablet: 4,
      laptop: 4,
      desktop: 4,
    },
  },
  "#top-hotels": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 4,
    },
  },
  "#global-infobar": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: false,
  },
  "#media-gallery": {
    breakpoints: {
      mobile: 1,
      tablet: 3,
      laptop: 3,
      desktop: 3,
    },
    activeSlide: 2,
    slideCount: 1,
  },
  "#what-guest-said": {    
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: true,
  },
  "#deck-plan": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
  },
  "#deck-plan-inner": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
  },
  "#tab-slider1": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 4,
    },
  },
  "#tab-slider2": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 4,
      desktop: 4,
    },
  },
  "#tab-slider3": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 4,
      desktop: 4,
    },
  },
  "#view-photos-inner": {
     breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    // activeSlide: 3,
    indicatorVisible: true,
  },
  "#view-videos-inner": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    // activeSlide: 3,
    indicatorVisible: true,
  },
  "#kids-specialists": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    autoplay: true,
    arrowsVisible: false,
  },
  "#seasonal-component": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: false,
  },  
  "#properties-interested": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 4,
      desktop: 4,
    },
  },
  "#hero-image-gallery": {
    breakpoints: {
      mobile: 1,
      tablet: 1,
      laptop: 1,
      desktop: 1,
    },
    arrowsVisible: true,
    indicatorVisible: false,
  },
  "#articles-and-guides": {
    breakpoints: {
      mobile: 1,
      tablet: 2,
      laptop: 3,
      desktop: 3,
    },
    arrowsVisible: true,
    indicatorVisible: true,
  },
  "#press-review": {
    breakpoints: {
      mobile: 1,
      tablet: 3,
      laptop: 3,
      desktop: 3,
    },
    indicatorVisible: true,
    arrowsVisible: false,
  },
};